import { render, staticRenderFns } from "./IconFileJpg.vue?vue&type=template&id=dd3b2086"
import script from "./IconFileJpg.vue?vue&type=script&lang=js"
export * from "./IconFileJpg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports